module.exports = __webpack_public_path__ + "assets/images/clt_r.2ed2d1cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/clt_r.png
// module id = 691
// module chunks = 1